import * as React from 'react';

import Tag16 from './Tag16';

export const tag16 = () => <Tag16 />;

export default {
    title: 'Icon/Fill/Tag16',
    component: Tag16,
    parameters: {
        notes: "`import Tag16 from 'box-ui-elements/es/icon/fill/Tag16';`",
    },
};
